import { serviceMaker, methods, api } from "@/http/index.js";

export const getPriorityMappingList = () =>
  serviceMaker(`/subcategory/all`, methods.GET, api.NGB);
export const getcategoryTemplate = (id) =>
  serviceMaker(`/subcategory/byCategory?category=${id}`, methods.GET, api.NGB);
export const getSubCategoryTemplate = () =>
  serviceMaker(`/subcategory/template`, methods.GET, api.NGB);
export const createNewSubCategory = (data) =>
  serviceMaker(`/subcategory`, methods.POST, api.NGB, data);
export const editcategoryTemplate = (id) =>
  serviceMaker(`/subcategory/subcategoryId/${id}`, methods.GET, api.NGB);
export const updateSubCategoryData = (id, payload) =>
  serviceMaker(`/subcategory/${id}`, methods.PUT, api.NGB, payload);
export const deletePriorityMappingList = (id) =>
  serviceMaker(`/subcategory/${id}`, methods.DELETE, api.NGB);
export const getViewPriorityMappingList = (id) =>
  serviceMaker(`/subcategory/all/${id}`, methods.GET, api.NGB);
